import { render, staticRenderFns } from "./SPIFProfileIntro.vue?vue&type=template&id=5d6e62e7"
import script from "./SPIFProfileIntro.vue?vue&type=script&lang=js"
export * from "./SPIFProfileIntro.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfileIntro.vue?vue&type=style&index=0&id=5d6e62e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports